import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { FC } from 'react'

import { InputCheckbox } from './components/InputCheckbox'
import { InputDropdown } from './components/InputDropdown'
import { InputImages } from './components/InputImages'
import { InputNumber } from './components/InputNumber'
import { InputText } from './components/InputText'

type PropsCardInputTypeProps = {
  data: orderApiSpace.ProductParamData
  productId: number
}

// выбор типов параметров
export const PropsCardInputType: FC<PropsCardInputTypeProps> = ({
  data,
  productId,
}) => {
  switch (data.typeCode) {
    case 'NUMBER':
      return <InputNumber data={data} productId={productId} key={data.id} />
    case 'DROPDOWN':
      return <InputDropdown data={data} productId={productId} key={data.id} />
    case 'CHECKBOX':
      return <InputCheckbox data={data} productId={productId} key={data.id} />
    case 'IMAGES':
      return <InputImages data={data} productId={productId} key={data.id} />
    case 'TEXT':
      return <InputText data={data} productId={productId} key={data.id} />
    default:
      return <></>
  }
}
